module.exports = __webpack_public_path__ + "img/rm_2.5e212936.png";